import { Col } from 'antd';
import React from 'react';
import { UpdateQueryParams } from '@hooks';
import { SearchFilter, SearchFilterContainer, SearchFilterQueryParams } from './filters';

export interface PeriscopeSearchProps {
	onChange: UpdateQueryParams<SearchFilterQueryParams>;
}

export const PeriscopeSearch: React.FC<PeriscopeSearchProps> = ({ onChange }) =>
	<SearchFilterContainer>
		<Col span={ 12 }>
			<SearchFilter onChange={ onChange } />
		</Col>
	</SearchFilterContainer>;

